import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

import {
  AvailablePermissionsResponse,
  CreateRoleResponse,
  RoleDetailResponse,
  RoleListResponse,
  UpdateRoleData,
} from './type';

export const getAvailablePermissions = (companyId: string) => {
  return API.get<ResponseBaseWithData<AvailablePermissionsResponse>>(
    `/api/v3/companies/${companyId}/permissions/available`,
  );
};

export const getRoleDetailById = (companyId: string, roleId: number) => {
  return API.get<ResponseBaseWithData<RoleDetailResponse>>(
    `/api/v3/companies/${companyId}/roles/${roleId}`,
  );
};

export const getRoleList = (companyId: string) => {
  return API.get<ResponseBaseWithData<RoleListResponse>>(`/api/v3/companies/${companyId}/roles`);
};

export const createRole = ({ companyId }: { companyId: string }) => {
  return API.post<ResponseBaseWithData<CreateRoleResponse>>(`/api/v3/companies/${companyId}/roles`);
};

export const duplicateRole = ({ companyId, roleId }: { companyId: string; roleId: number }) => {
  return API.post<ResponseBaseWithData<CreateRoleResponse>>(
    `/api/v3/companies/${companyId}/roles/${roleId}/clone`,
  );
};

export const deleteRole = ({ companyId, roleId }: { companyId: string; roleId: number }) => {
  return API.delete<ResponseBaseWithData>(`/api/v3/companies/${companyId}/roles/${roleId}`);
};

export const updateRole = ({
  companyId,
  roleId,
  request,
}: {
  companyId: string;
  roleId: number;
  request: UpdateRoleData;
}) => {
  return API.put<ResponseBaseWithData>(`/api/v3/companies/${companyId}/roles/${roleId}`, {
    data: request,
  });
};

export const getUserPermissions = ({
  companyId,
  userId,
}: {
  companyId: string;
  userId: string;
}) => {
  return API.get<ResponseBaseWithData<RoleDetailResponse>>(
    `/api/v3/companies/${companyId}/users/${userId}/permissions`,
  );
};
